import { SxProps, Theme } from "@mui/material";
import { CSSProperties } from "react";

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    minHeight: "100vh",
    background: "#f5f5f7",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    py: 3,
    borderBottom: "1px solid #e0e0e0",
    background: "#fff",
  },
  content: {
    flex: 1,
    px: 4,
    py: 3,
  },
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
  },
  errorBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    gap: 2,
  },
  errorAlert: {
    maxWidth: 480,
  },
};

export const logoStyle: CSSProperties = {
  height: 40,
};
